module.exports = __webpack_public_path__ + "static/media/third_declension4_img.aa0e77c3.JPG";